export const canLogEvents = () => {
  return process.env.NODE_ENV === 'production';
};
